import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=fc319184"
import script from "./DocumentsNew.vue?vue&type=script&lang=ts"
export * from "./DocumentsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc319184')) {
      api.createRecord('fc319184', component.options)
    } else {
      api.reload('fc319184', component.options)
    }
    module.hot.accept("./DocumentsNew.vue?vue&type=template&id=fc319184", function () {
      api.rerender('fc319184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/DocumentsNew.vue"
export default component.exports